/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSitePortefeuilleResponseDto } from '../../models/get-site-portefeuille-response-dto';

export interface GetPortefeuille$Params {
  /**
   * id_intervenant
   */
  id_intervenant: string;
}

export function getPortefeuille(
  http: HttpClient,
  rootUrl: string,
  params: GetPortefeuille$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, getPortefeuille.PATH, 'get');
  if (params) {
    rb.path('id_intervenant', params.id_intervenant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>;
    })
  );
}

getPortefeuille.PATH = '/v2/portefeuilles/{id_intervenant}';
